import React, { Component, Fragment } from "react";
import { Grid, Image, Container } from 'semantic-ui-react';
import classNames from "classnames";
import userImage from "../../semantic/dist/themes/fibrestream/assets/images/user.png";
import TvModal from "../header/modals/TvModal";
import { connect } from 'react-redux';
import { googleTracking } from "../../util";

class NeedHelpFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      activeModal: false,
      tvVisible: false,
      visiblePhoneNum: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showPhoneNum = this.showPhoneNum.bind(this);
  }

  openModal(modalName) {
    this.setState({
      activeModal: modalName,
      tvVisible: (modalName === 'tv')
    });
  }

  closeModal() {
    this.setState({
      tvVisible: false
    });

    setTimeout(() => {
      this.setState({
        activeModal: false
      });
    }, 500);
  }
  showPhoneNum() {
    const { connection } = this.props;

    let gaEvent = {
      event: "GAevent",
      eventCategory: "show-number",
      eventAction: "click",
      eventLabel: ''
    };

    if (connection.status === 'AVAILABLE_NOT_PREWIRED') {
      gaEvent['metric11'] = '1';
    } else {
      gaEvent['metric10'] = '1';
    }

    googleTracking(gaEvent);

    this.setState({
      visiblePhoneNum: true
    })
  }

  render() {
    const { activeModal, tvVisible, visiblePhoneNum } = this.state;
    const { promotion, sales_rep } = this.props;
    let name = '';
    let phone = '';
    let phoneNum = '';
    if (promotion.length === 1 && promotion[0].sales_rep_name) {
      name = promotion[0].sales_rep_name;
      phoneNum = promotion[0].sales_rep_phone;
      phone = promotion[0].sales_rep_phone;
      
      if (!visiblePhoneNum && phone) {
        phone = phone.substring(0, 10);
      }

    }
    else {
      name = sales_rep.sales_rep_name;
      phone = sales_rep.sales_rep_phone;
      phoneNum = sales_rep.sales_rep_phone;

      if (!visiblePhoneNum && phone) {
        phone = phone.substring(0, 10);
      }
    }
    return (
      <Fragment>
        {
        (phone && name) &&
        <div className="bg--grey footer__sign-up mx-0">
        <Container>
          <Grid textAlign='center' className="mx-0">
            <Grid.Row columns={3} centered className='text-grey py-0'>
              <Grid.Column computer={4} tablet={6} mobile={16} className="footer__left" textAlign='center'>
                <div>
                  <p className="itc-mdbold f-size--14 text-grey5 title">Need more help?</p>
                  <p className='f-size--14 text-grey6 desc'>Call your local sales rep, {name}</p>
                  <Image className='gray-scale icon--user' src={userImage} avatar verticalAlign='middle' />


                  <a href={'tel:' + phoneNum} className={classNames({ "no-decoration": !visiblePhoneNum }, "f-size--14 ")}>
                    {
                      visiblePhoneNum ? phone : `${phone}XXXX`
                    }
                  </a>&nbsp;&nbsp;<span className={classNames({ "d-none": visiblePhoneNum }, "text-underline cursor-pointer")} onClick={this.showPhoneNum}>show</span>
                </div>
              </Grid.Column>
              {/* <Grid.Column computer={6} tablet={8} mobile={16} className="footer__right">
                <p className="itc-mdbold f-size--14 text-grey5 title">How can I order TV?</p>
                <p className="f-size--14 text-grey6 desc">TV must be ordered separately via one of our TV partners. <a className="cursor-pointer" onClick={() => this.openModal('tv')}>Go here to learn more.</a></p>
              </Grid.Column> */}
            </Grid.Row>
          </Grid>
        </Container>
        <TvModal open={activeModal === 'tv'} visible={tvVisible} closeModal={this.closeModal} />
      </div >
        }
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    sales_rep: state.sales_rep,
    promotion: state.promotion,
    connection: state.connection
  }
}

export default connect(mapStateToProps)(NeedHelpFooter);


// WEBPACK FOOTER //
// ./src/components/footer/NeedHelpFooter.js